import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@lib/api";
import { API_ROUTES } from "../constants";

export type ArticleLikeCountData = { likeCount: number; liked: boolean };

export const QUERY_KEY = "getArticleLikeCount";

export const useGetArticleLikeCount = (articleId: number | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEY, articleId],
    queryFn: async (): Promise<ArticleLikeCountData> => {
      const response = await apiClient.get<ArticleLikeCountData>(
        `${API_ROUTES.articleLikeCount}/${articleId}`
      );
      return response.data;
    },
    enabled: !!articleId,
  });
};
